import { Component, Input, OnInit } from "@angular/core";
import { Wiring } from "../../../../../codegen/out/types";

@Component({
  selector: "app-bu-wiring-diagram",
  templateUrl: "./bu-wiring-diagram.component.html",
  styleUrls: ["./bu-wiring-diagram.component.scss"],
  standalone: false,
})
export class BuWiringDiagramComponent implements OnInit {
  @Input() wiring: Wiring;

  terminals = {};

  externalPowerSupplyNeeded = false;
  jumperImage: string = null;

  ngOnInit(): void {
    for (const terminal of this.wiring.terminals) {
      this.terminals[terminal.device] = terminal;
    }

    if (this.wiring.externalPowerSupplyNeeded) {
      this.externalPowerSupplyNeeded = true;
    }

    if (this.wiring.jumperPosition === "POSITION_1") {
      this.jumperImage = "assets/wiring-bu-jumper-position1.svg";
    } else if (this.wiring.jumperPosition === "POSITION_2") {
      this.jumperImage = "assets/wiring-bu-jumper-position2.svg";
    }
  }
}
